<template>
    <div id="app">
        <!--<navbar-header/>-->

        <router-view></router-view>

        <transition name="fade">
            <no-internet v-if="NoInternetPopup"></no-internet>
        </transition>
        <transition name="fade">
            <rotate-phone v-if="rotatePhonePopup"></rotate-phone>
        </transition>

        <scanning v-if="ScanningPopup" />
        <download v-if="DownloadPopup" :percent="DownloadPopupPercent" :description="downloadDescription" />
        <error-download v-click-outside="closeErrorPopup" v-if="ErrorDownloadPopup" :title="errorPopupTitle" :description="errorPopupDescription" />

        <div v-show="NoInternetTransparent" @click="openNoInternet" class="offline-cover"></div>
    </div>
</template>

<script>
    import Header from '../components/Header.vue';
    import NoInternet from '../components/pop-up/NoInternet.vue';
    import ErrorDownload from '../components/pop-up/ErrorDownload.vue';
    import Download from '../components/pop-up/Download.vue';
    import Scanning from '../components/pop-up/Scanning.vue';
    import rotatePhone from '../components/pop-up/RotatePhone.vue';
    import authMixin from '../mixins/auth';
    import ClickOutside from '../plugins/ClickOutside';

    export default {
        components: {
            'navbar-header': Header,
            NoInternet,
            rotatePhone,
            ErrorDownload,
            Download,
            Scanning,
        },
        directives: {
            ClickOutside,
        },
        mixins: [
            authMixin,
        ],
        data() {
            return {
                NoInternetPopup: false,
                NoInternetTransparent: false,
                rotatePhonePopup: false,
                ErrorDownloadPopup: false,
                DownloadPopup: false,
                ScanningPopup: false,
                DownloadPopupPercent: 0,
                downloadDescription: 'System Message Error Message',
                errorPopupDescription: 'Error Message Error Message Error Message',
                errorPopupTitle: this.$t("translation.errorDownloading"),
            };
        },
        methods: {
            openNoInternet() {
                this.NoInternetPopup = true;
            },
            closeErrorPopup() {
                this.ErrorDownloadPopup = false;
            },
        },
        mounted() {
            window.addEventListener('online', () => {
                if (this.$route.name !== 'workspace') {
                    this.NoInternetTransparent = false;
                    this.NoInternetPopup = false;
                    window.location.reload();
                }
            });

            window.addEventListener('offline', () => {
                if (this.$route.name !== 'workspace') {
                    this.NoInternetTransparent = true;
                }
            });

            window.addEventListener('resize', () => {
                if ( $(window).width() > $(window).height() ) {
                    this.rotatePhonePopup = false;
                } else {
                    this.rotatePhonePopup = true;
                }
            });

            window.dispatchEvent(new Event('resize'));

            try {
                const arrayStrings = window.location.hash.split('?')[1].split('&').map((element) => {
                    return element.split('=');
                });

                const resultData = arrayStrings.filter(element => element[0] === 'lang')[0][1];

                if (resultData) {
                    try {
                        console.log('lang-changed');

                        window.invokeCSCode('lang-changed');
                    } catch (e) {
                        // Code
                    }

                    this.$nextTick(() => {
                        const language = this.languages.find(el => el.language === resultData);

                        if (language) {
                            this.$store.commit('auth/DEFAULT_LANGUAGE', language.language);
                            this.$store.commit('auth/DEFAULT_DIRECTION', language.direction);
                        }
                    });
                }
            } catch (e) {
                // Code
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.name === 'workspace') {
                    this.NoInternetTransparent = false;
                    this.NoInternetPopup = false;
                } else if (from.name === 'workspace') {
                    this.$store.commit('auth/DEFAULT_LANGUAGE', window.getAppStorage('locale') || 'en');
                    this.$store.commit('auth/DEFAULT_DIRECTION', window.getAppStorage('direction') || 'ltr');
                }
            },
        },
    };
</script>

<style lang="scss">
    .slide-fade-enter-active {
        transition: all .2s ease;
    }

    .slide-fade-leave-active {
        transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-active {
        transform: translateX(10px);
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/App.vue